﻿import { useMemo } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import BaseModal from '@/components/modals/BaseModal';
import { close } from '@/store/uiSlice.ts';
import { useI18nContext } from '@/i18n/i18n-react';
import { useGetPlanResourcesQuery } from '@/store/apiSlice';

const AbsentModal = () => {
    const dispatch = useAppDispatch();
    const open = useAppSelector((state) => state.ui.open.absent);
    const onClose = () => dispatch(close('absent'));
    const { LL } = useI18nContext();

    const absentUsers = useAppSelector((state) => state.modal.absentUsers);
    const modalContextDate = useAppSelector((state) => state.modal.modalContextDate);

    // On a hard reload the absentUsers list is empty (it was set by Event.tsx which hasn't
    // rendered yet).  Re-derive the list from the cached plan data when needed.
    const forecast = useAppSelector((state) => state.ui.forecast);
    const history = useAppSelector((state) => state.ui.open.history);

    const { data: planData } = useGetPlanResourcesQuery(
        { forecast, includeHistory: history },
        { skip: absentUsers.length > 0 || !open || !modalContextDate }
    );

    const displayedAbsentUsers = useMemo(() => {
        if (absentUsers.length > 0) return absentUsers;
        if (!planData || !modalContextDate) return [];
        const event = planData.find((e) => e.date === modalContextDate);
        return event?.absent ? Object.values(event.absent) : [];
    }, [absentUsers, planData, modalContextDate]);

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            maxWidth="xs"
            title={LL.absentModal.title()}
            actions={<Button onClick={onClose}>{LL.common.close()}</Button>}
        >
            <TableContainer component={Paper} variant="outlined">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LL.absentModal.user()}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedAbsentUsers.map((user, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{user}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </BaseModal>
    );
};

export default AbsentModal;
